import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Accordion from './Accordion';

/**
 * Displays a basic accordion
 */
class BasicAccordion extends React.Component {
  static propTypes = {
    /** accordion content: array of elements, each having props for key*, header
     and headerProperties and content as children */
    children: PropTypes.arrayOf(
      PropTypes.shape({
        props: PropTypes.shape({
          id: PropTypes.string.isRequired,
          header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
          headerProperties: PropTypes.object,
          className: PropTypes.string
        })
      })
    ),

    /** display the collapse arrow on left side instead of right */
    leftAlignCollapseArrow: PropTypes.bool,

    /**  Less padding e.g. for mobile view usage */
    isTight: PropTypes.bool,
    /** Expands the accordion element */
    expanded: PropTypes.bool,
    className: PropTypes.any
  };

  constructor(props) {
    super(props);
    this.state = {
      expanded: props.expanded
    };
  }

  toggle = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  render() {
    const {isTight, leftAlignCollapseArrow, children, className} = this.props;

    const classes = [
      'ea-accordion',
      {'ea-accordion--arrow-left': !!leftAlignCollapseArrow},
      {'ea-accordion--tight': !!isTight}];

    return (
      <div className={ classnames(className, classes)} >
        {
          children.map( (element) => {
            return <Accordion key={element.props.id} {...element.props} />;
          })
        }
      </div>);
  }

}

export default BasicAccordion;



// WEBPACK FOOTER //
// ./web/js/components/react-patterns/accordion/BasicAccordion.js